import './index.scss';

const PageDescription = ({ label, className = '', children = undefined, ...rest }) => ((children || label) ? (
    <p className={`page-description ${className}`} {...rest}>
        {children || label}
    </p>
) : null);

export default PageDescription;
